var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigcartel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.421v-1.339c0-0.837 0.339-1.676 1.172-2.009l10.391-6.537c0.667-0.333 1.005-1.172 1.005-2.009v-5.527l-12.568 8.041-12.568-8.041v16.921c0 4.527 2.016 8.376 5.36 10.552l7.041 4.527 7.041-4.527c3.349-2.009 5.36-5.859 5.36-10.552v-7.541z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcartel);
export default __webpack_public_path__ + "static/media/Big cartel.dd3d673335222ea49bec5989bb322e76.svg";
export { ForwardRef as ReactComponent };